<template>
  <div class="lbv-search animated fadeIn roundedCard">
    <b-card>
      <h1 class="lbv-page-title">
        Search
      </h1>
      <form
        class="lbv-search-filter"
        @submit.prevent="searchFunction"
      >
        <div class="lbv-search-type">
          <label><strong>Search Type: </strong></label>
          <select
            v-model="searchType"
            accesskey="/"
          >
            <option value="last_name">
              Surname
            </option>
            <option value="post_code">
              Postcode
            </option>
            <option value="first_name">
              First name
            </option>
            <option value="LeakBotId">
              LeakBot ID
            </option>
            <option value="DeviceName">
              SigFox ID
            </option>
            <option value="username">
              Username
            </option>
            <option value="serial_number">
              Serial Number
            </option>
          </select>
        </div>
        <div class="lbv-search-action">
          <label><strong>Search: </strong></label>
          <input
            v-model="searchString"
            type="text"
            class="form-control"
            required
          >
          <button
            id="ButtonSignIn-id"
            type="submit"
            class="btn btn-primary login"
          >
            Search
          </button>
        </div>
      </form>
      <b-alert
        :show="errorString != &quot;&quot;"
        variant="danger"
      >
        {{ errorString }}
      </b-alert>
      <b-table
        responsive
        hover
        :items="$store.state.searchResults"
        :fields="fields"
      >
        <template
          slot="leakbotId"
          slot-scope="data"
        >
          <router-link
            :to="{ name: 'DeviceView', params: { deviceID: data.value }}"
            class="deviceLink"
          >
            {{ data.value }}
          </router-link>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import searchMixin from '../mixins/searchMixin'

export default {
  name: 'Search',
  mixins: [searchMixin]
}
</script>
